module.exports = __webpack_public_path__ + "static/media/cheryl-cole-lose.03855fe4.jpg";